"use strict";
exports.__esModule = true;
exports.Engraving = exports.NoneEngraving = exports.BitmapEngraving = exports.VectorEngraving = exports.SymbolEngraving = exports.TextEngraving = void 0;
var core_common_logic_1 = require("@jewelutions/core-common-logic");
var core_common_domain_1 = require("@jewelutions/core-common-domain");
var Design_1 = require("./Design");
var uuid_1 = require("uuid");
var TextEngraving = /** @class */ (function () {
    function TextEngraving() {
    }
    TextEngraving.FONT_SIZE_MAX = -1;
    TextEngraving.LINE_SPACING_MAX = -1;
    return TextEngraving;
}());
exports.TextEngraving = TextEngraving;
var SymbolEngraving = /** @class */ (function () {
    function SymbolEngraving() {
    }
    SymbolEngraving.SCALING_FACTOR_MAX = -1;
    return SymbolEngraving;
}());
exports.SymbolEngraving = SymbolEngraving;
var VectorEngraving = /** @class */ (function () {
    function VectorEngraving() {
    }
    VectorEngraving.SCALING_FACTOR_MAX = -1;
    VectorEngraving.EMPTY_VECTOR = {
        contentType: core_common_domain_1.MimeType.SVG,
        contentBase64: core_common_logic_1.CommonLogic.Base64.encode("<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?>\n    <!DOCTYPE svg PUBLIC \"-//W3C//DTD SVG 1.1//EN\" \"http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd\">\n    <svg overflow=\"visible\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\">  \n    </svg>\n    ")
    };
    return VectorEngraving;
}());
exports.VectorEngraving = VectorEngraving;
var BitmapEngraving = /** @class */ (function () {
    function BitmapEngraving() {
    }
    BitmapEngraving.SCALING_FACTOR_MAX = -1;
    BitmapEngraving.EMPTY_IMAGE = {
        contentType: core_common_domain_1.MimeType.PNG,
        contentBase64: "iVBORw0KGgoAAAANSUhEUgAAAsAAAAGMAQMAAADuk4YmAAAAA1BMVEX///+nxBvIAAAAAXRSTlMAQObYZgAAADlJREFUeF7twDEBAAAAwiD7p7bGDlgYAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAwAGJrAABgPqdWQAAAABJRU5ErkJggg=="
    };
    return BitmapEngraving;
}());
exports.BitmapEngraving = BitmapEngraving;
var NoneEngraving = /** @class */ (function () {
    function NoneEngraving() {
    }
    NoneEngraving.SCALING_FACTOR_MAX = -1;
    return NoneEngraving;
}());
exports.NoneEngraving = NoneEngraving;
var Engraving = /** @class */ (function () {
    function Engraving() {
    }
    Engraving.createTextEngraving = function (editableAreaId, text, fontId, fontSize, lineSpacing) {
        if (fontSize === void 0) { fontSize = TextEngraving.FONT_SIZE_MAX; }
        if (lineSpacing === void 0) { lineSpacing = TextEngraving.LINE_SPACING_MAX; }
        var result = {
            id: uuid_1.v4(),
            editableAreaId: editableAreaId,
            position: {
                x: 0,
                y: 0
            },
            alignment: core_common_domain_1.Alignment.CENTER,
            type: Design_1.EngravingType.TEXT,
            text: {
                fontId: fontId,
                fontSize: fontSize,
                lineSpacing: lineSpacing,
                text: text
            }
        };
        return result;
    };
    Engraving.createLetterEngraving = function (editableAreaId, letter, fontId, fontSize) {
        if (fontSize === void 0) { fontSize = TextEngraving.FONT_SIZE_MAX; }
        var result = {
            id: uuid_1.v4(),
            editableAreaId: editableAreaId,
            position: {
                x: 0,
                y: 0
            },
            alignment: core_common_domain_1.Alignment.CENTER,
            type: Design_1.EngravingType.SINGLE_LETTER,
            text: {
                fontId: fontId,
                fontSize: fontSize,
                lineSpacing: 0,
                text: [letter]
            }
        };
        return result;
    };
    Engraving.createSymbolEngraving = function (editableAreaId, symbolId, scalingFactor) {
        if (scalingFactor === void 0) { scalingFactor = SymbolEngraving.SCALING_FACTOR_MAX; }
        var result = {
            id: uuid_1.v4(),
            editableAreaId: editableAreaId,
            position: {
                x: 0,
                y: 0
            },
            alignment: core_common_domain_1.Alignment.CENTER,
            type: Design_1.EngravingType.SYMBOL,
            symbol: {
                scalingFactor: scalingFactor,
                symbolId: symbolId
            }
        };
        return result;
    };
    Engraving.createNoneEngraving = function (editableAreaId) {
        var result = {
            id: uuid_1.v4(),
            editableAreaId: editableAreaId,
            position: {
                x: 0,
                y: 0
            },
            alignment: core_common_domain_1.Alignment.CENTER,
            type: Design_1.EngravingType.NONE
        };
        return result;
    };
    return Engraving;
}());
exports.Engraving = Engraving;
